<!-- @format -->
<template>
	<div class="page-inner-link">
		<pcp-mo-layout-component-inner-link :key="link" :link="link" />
	</div>
</template>

<script lang="ts" setup>
	import { getEnvUrlByUrl } from '@power/runtime-vue3';
	import { useMoGlobalStoreWithOut } from '@/store/modules/moglobal';
	import { PcpMoLayoutComponentInnerLink } from '@/p-layout/mobile/components/inner-link/index';
	const moglobalStore = useMoGlobalStoreWithOut();
	const route = useRoute();

	const targeturl = (route.query.targeturl as string) || '';
	const navigationBarTitle = (route.query.navigationBarTitle as string) || '';
	const url = getEnvUrlByUrl(decodeURIComponent(targeturl));
	const link = ref(url);
	const title = ref(navigationBarTitle);
	const refresh = () => {
		const targeturl = (route.query.targeturl as string) || '';
		const navigationBarTitle = (route.query.navigationBarTitle as string) || '';
		const url = getEnvUrlByUrl(decodeURIComponent(targeturl));
		if (link.value !== url) {
			link.value = url;
		}
		title.value = navigationBarTitle;
		moglobalStore.setNavigationBar({
			title: navigationBarTitle,
			leftArrow: true,
		});
	};
	refresh();
	watch(
		() => route.query,
		() => {
			refresh();
		},
	);
</script>

<style scoped lang="scss"></style>
